import { DataType } from './DataType';
import { FView } from '../FView';
import { RecordBase } from './sets/RecordBase';
import { DataPeriod } from './DataPeriod';
import { Place } from './company/Place';
import { DataFormats } from './formats/DataFormats';
import { TypeMappings } from './TypeMappings';

export class DataManager {
    private place: Place | null = null;
    private places: Place[] | null = null;
    private dataSets: Record<string, any> = {};

    public LoadData(
        period: DataPeriod | null = null,
        companyId: number | null = null,
        user: string | null = null, 
        ignoreExternal: boolean = false,
        placeName: string | null = null,
    ) : Promise<void> {
        return FView.Get().rawDataManager.LoadRawData(period, companyId, user, ignoreExternal)
            .then(() => this.ProcessData(placeName) );
    }

    public ProcessData(placeName: string | null = null) {
        let rawContainer = FView.Get().rawDataManager.GetRawData();
        let company = rawContainer.companies[rawContainer.company];

        Object.setPrototypeOf(rawContainer.currentRange, DataPeriod.prototype);
        Object.setPrototypeOf(rawContainer.availableRange, DataPeriod.prototype);

        this.places = [];
        for (let company of rawContainer.companies) {
            for (let place of company.places) {
                this.places.push(new Place(company, place));
            }
        }

        if (company.places.length > 0) {
            if (this.place == null || this.place.company.id != company.id || !company.places.includes(this.place.name)) {
                this.place = new Place(company, company.places[0]);
                if (placeName != null && company.places.includes(placeName)) {
                    this.place.name = placeName;
                }
            }

            let format = DataFormats.GetFormat(company.typeMeta.apiPath);
            if (format != null) {
                let dataSets = this.ReformatDataSets(rawContainer.dataSets);
                dataSets = format.filterByPlace(dataSets, this.place.name);
                this.dataSets = format.processDataSets(dataSets, this.place);
            } else {
                console.error("Unknown company format: " + company.type);
            }
        } else {
            console.warn("Selected company has no places!");
        }
    }



    private ReformatDataSets(rawDataSets: Record<string, any>) : Record<number, RecordBase[]> {
        let dataSets:Record<number, RecordBase[]> = {};
        for (let type of Object.keys(rawDataSets)) {
            //@ts-ignore
            let dsType: DataType = DataType[type as string];
            let ctr = TypeMappings.GetType(dsType);
            dataSets[dsType] = [];
            for (let i in rawDataSets[type]) {
                dataSets[dsType][i as unknown as number] = Object.assign(new ctr(), rawDataSets[type][i]);
            }
        }
        return dataSets;
    }





    public SelectPlace(place: Place): Promise<void> | null {
        if (this.place == null || place.company.id != this.place.company.id) {
            this.place = place;
            return this.LoadData(this.GetCurrentRange(), place.company.id)
        } else {
            this.place = place;
            this.ProcessData();
            return null;
        }
    }

    public SelectRange(range: DataPeriod) {
        return this.LoadData(range, this.GetPlace().company.id)
    }

    public GetPlace(): Place {
        return this.place as Place;
    }

    public GetCurrentRange(): DataPeriod {
        return FView.Get().rawDataManager.GetRawData().currentRange;
    }

    public GetWholeRange() {
        return FView.Get().rawDataManager.GetRawData().availableRange;
    }

    public GetPlaces() {
        return this.places;
    }





    public GetDataset<T extends RecordBase>(type: DataType) : T[] {
        return this.dataSets[type] as T[];
    }

    public GetShownRecords<T extends RecordBase>(type: DataType): T[] {
        let dataSet = this.GetDataset<T>(type);
        return dataSet.filter(r => r.shown);
    }

    public HasDataset(type: DataType) : boolean {
        return this.dataSets.hasOwnProperty(type);
    }
}


